import "./data-direct.less";
import { IComponentOptions, IComponentController, IOnChangesObject } from 'angular';
import { IInstanceSettings, IInstanceSettingsDto, IRegistryEntry } from "../../typings/board/Models";
import { DATA_DIRECT_SERVICE, DataDirectService } from "./data-direct.service";


import './data-direct.less';
import * as angular from "angular";
import { map, transform } from "lodash";
import { Description } from "../capsule-manager-guide/capsuleManagerGuide.component";

export const DATA_DIRECT_COMPONENT = "dataDirectComponent";

class DataDirectComponentController implements IComponentController {
    private settings: IInstanceSettingsDto;
    private existingConfigurations: IRegistryEntry[];
    private machineName: string;
    private descriptions : Description[];

    private showPassword = true;
    private newConfigurationName: string;
    private newDataSourceName: string;

    //Labels
    get titleLabel() { return "BOARD Cloud Data Pipeline"; }
    get subTitleLabel() { return "Configure connections to your data sources on-premises or in cloud" }
    get connectionHint() { return "These connections can be used on any BOARD instance (Production, Sandbox, ...)" }
    get firstStep() { return "To activate the BOARD Cloud Data Pipeline service you have to access the portal and change the first password." }
    get secondStepText() { return "     " }
    get secondStepLink() { return "OPC (On-Premise Connector)" }
    get thirdStep() { return "Add a new Data Source here:" }
    get dataPipelineAccess() { return "Cloud Data Pipeline Portal" }
 
    get footer1() {return "The above alias will be available on "}
    get footer2() {return "instance only"}
    get footer3() { return "User and password of the BOARD Data Reader login settings are the same credential of the Cloud Data Pipeline Portal" }
    get oDBCLabel() { return "" }
    get oDBCSubLabel() { return "In order to use a data source in a BOARD SQL Data Reader you must define an alias." }
    get serverLinkLabel(): string { return "Configure a Data Source Connection" }
    get userLabel(): string { return "User:"; }
    get passLabel(): string { return "First password:"; }
    get onPremiseLinkLabel(): string { return "To connect to an on-premise data source, download the On-Premise Connector here."; }
    get getStartedLinkLabel(): string { return "Download Data Pipeline guide"; }
    get addConfLabel(): string { return "Add new"; }
    get newConfLabel(): string { return "Data Source name"; }
    get oDBCNameLabel(): string { return "BOARD Connection Source name"; }
    get dataSourceLabel(): string { return "Data Pipeline Data Source name"; }

    get dataDirectLink(): string { return this.settings.dataDirectLoginLink; }
    get username(): string { return this.settings.dataDirectUsername; }
    get password(): string { return this.settings.dataDirectPassword; }
    get onPremiseLink(): string { return this.settings.onPremiseLink; }
    get getStartedLink(): string { return this.settings.getStartedLink; }

    get instanceName() { return this.settings.hostname; }
    get instanceNameLink() { return this.settings.hostnameLink; }
    get instanceType() { return this.settings.instanceType; }

    //Disabled
    get enabledOnPremiseLink(): boolean { return this.settings && this.settings.onPremiseLink && this.settings.onPremiseLink !== ""; }
    get enabledGetStartedLink(): boolean { return this.settings && this.settings.getStartedLink && this.settings.getStartedLink !== ""; }

    static $inject = ["$mdToast", DATA_DIRECT_SERVICE, "$mdDialog"];
    constructor(private $mdToast: ng.material.IToastService, private dataDirectService: DataDirectService, private $mdDialog: ng.material.IDialogService) { 
        this.descriptions = [];
        // tslint:disable-next-line:max-line-length
        this.descriptions.push(new Description("Data pipeline", "Configure connections to your data sources, on premise or cloud. Access to data pipeline portal, add new data sources if needed."));
    }


    $onInit() { }

    $onChanges(onChangesObj: IOnChangesObject) {
    }

    private showCopyMsg() {
        this.$mdToast.show(this.$mdToast.simple().textContent("Copied to clipboard!").position("top right"));
    }

    private showPassOnClick() {
        this.showPassword = !this.showPassword;
    }

    private commitNewConfiguration() {
        this.dataDirectService.createODBCConfiguration(this.newConfigurationName, this.newDataSourceName).then(
            (response) => {
                this.newConfigurationName = "";
                this.dataDirectService.getExistingConfigurations().then(
                    (response) => {
                        this.existingConfigurations = response;

                    }, (reason) => {

                    });

            }, (reason) => {

            });
    }

    private addConfOnClick() {

        this.$mdDialog.show({
            controller: CreateConnectionController,
            controllerAs: "$ctrl",
            template: require("./update-connection.html"),

        }).then((answer) => {
            this.dataDirectService.createODBCConfiguration(answer.connectionName, answer.dataSourceName).then(
                (response) => {
                    this.newConfigurationName = "";
                    this.dataDirectService.getExistingConfigurations().then(
                        (response) => {
                            this.existingConfigurations = response;
                        }, (reason) => {
                        });
                }, (reason) => {

                });
        }, () => {

        });


    }
    private showPasswordSecurity() {
        this.$mdDialog.show({
            controller: SecurityNoticeController,
            controllerAs: "$ctrl",
            template: require("./security-alert.html")
        });
    }

    private deleteODBCConfiguration(name: string) {
        this.dataDirectService.deleteODBCConfiguration(name).then(
            (response) => {
                this.dataDirectService.getExistingConfigurations().then(
                    (response) => {
                        this.existingConfigurations = response;
                    }
                );
            });
    }

    private showUpdateConfigurationDialogue(oldConnectionName: string, oldDataSourceName: string) {
        this.$mdDialog.show({
            controller: EditConnectionController,
            controllerAs: "$ctrl",
            template: require("./update-connection.html"),
            locals: { oldConnectionName: oldConnectionName, oldDataSourceName: oldDataSourceName },
        }).then((answer) => {
            this.dataDirectService.updateODBCConfiguration(answer.oldConnectionName, answer.newConnectionName, answer.newDataSourceName).then(
                (response) => {
                    this.newConfigurationName = "";
                    this.dataDirectService.getExistingConfigurations().then((response) => {
                        this.existingConfigurations = response;
                    }, (reason) => {
                    });
                }, (reason) => {
                });
        }, (reason) => {
        });

    }
}

class SecurityNoticeController {
    get securityAlertTitle() { return "For security reasons the password must respect the following policies:" }
    get securityList() {
        return [
            "be at least eight characters long,",
            "contain a combination of upper- and lower-case letters,",
            "contain numbers",
            "contain punctuation marks and other special characters"
        ]
    }
    constructor(private $mdDialog: ng.material.IDialogService) {

    }
    static $inject = [
        "$mdDialog",
    ];

    private close() {
        this.$mdDialog.cancel();
    }
}

class CreateConnectionController {
    get oDBCNameLabel(): string { return "BOARD"; }
    get dataSourceLabel(): string { return "Data Pipeline"; }

    static $inject = [
        "$mdDialog",
    ];

    constructor(private $mdDialog: ng.material.IDialogService) {

    }

    private newConnectionName: string;
    private newDataSourceName: string;



    private cancel() {
        this.$mdDialog.cancel();
    }

    private save() {
        this.$mdDialog.hide({
            connectionName: this.newConnectionName,
            dataSourceName: this.newDataSourceName
        })
    }

}

class EditConnectionController {
    get oDBCNameLabel(): string { return "BOARD"; }
    get dataSourceLabel(): string { return "Data Pipeline"; }

    static $inject = [
        "$mdDialog",
        "oldConnectionName",
        "oldDataSourceName"
    ];

    constructor(private $mdDialog: ng.material.IDialogService, private oldConnectionName: string, private oldDataSourceName: string) {
        this.newConnectionName = oldConnectionName;
        this.newDataSourceName = oldDataSourceName;
    }

    private newConnectionName: string;
    private newDataSourceName: string;


    private cancel() {
        this.$mdDialog.cancel();
    }

    private save() {
        this.$mdDialog.hide({
            oldConnectionName: this.oldConnectionName,
            newConnectionName: this.newConnectionName,
            newDataSourceName: this.newDataSourceName
        })
    }

}

export const dataDirectComponentOptions: IComponentOptions = {
    controller: DataDirectComponentController,
    template: require("./data-direct.html"),
    bindings: {
        settings: "<",
        machineName: "<",
        existingConfigurations: "<"
    }
};


// WEBPACK FOOTER //
// ./app/data-direct/data-direct.component.ts